import {useDispatch, useSelector} from 'react-redux';
import {additionalData} from '../store/reducers/additionalData';
import {
    ctxPatientType,
    setBlockDischargeMandatoryAssessment,
    setMandatoryAssessmentList,
} from '../store/reducers/patientContext';
import {useEffect, useState} from 'react';
import _ from 'lodash';
import moment from 'moment/moment';
import {agyleAssessmentList} from '../store/reducers/dicts';
import {formIds} from '../pages/patient/patientContext/components/forms/formsId';
import {assessmentsConfig} from '../store/reducers/externalConfig';
import {DEFAULT_ASSESSMENTS_VALUE} from '../pages/admin/aglyeConfig/configDefaultValues';
import {PATIENT_CONTEXT_TYPE} from '../util/patientContextUtil';

const useAllAssessmentsFiled = (patient) => {
    const dispatch = useDispatch();

    // Selectors
    const patientAddData = useSelector(additionalData);
    const assessmentList = useSelector(agyleAssessmentList);
    const assessmentsCfg = useSelector(assessmentsConfig);
    const patientType = useSelector(ctxPatientType);
    const assCfg = useSelector(assessmentsConfig);

    const [filteredAssessmentsList, setFilteredAssessmentsList] = useState([]);
    const [noFilled, setNoFilled] = useState(false);
    const [assessmentsLists, setAssessmentsLists] = useState([]);

    const prepareAssessmentList = (listOfIds) => {
        const assessments = [];
        if (!_.isEmpty(listOfIds)) {
            _.forEach(listOfIds, id => {
                const findAss = _.find(assessmentList, {code: id});
                if (findAss) assessments.push(findAss);
            });
        }
        setFilteredAssessmentsList(assessments);
    };

    useEffect(() => {
        switch (patientType) {
            case PATIENT_CONTEXT_TYPE.ED:
            case PATIENT_CONTEXT_TYPE.FAST_REGISTRY:
            case PATIENT_CONTEXT_TYPE.TEMPORARY:
                prepareAssessmentList(assessmentsCfg?.ED?.mandatory);
                break;
            case PATIENT_CONTEXT_TYPE.EDAU:
                prepareAssessmentList(assessmentsCfg?.EDAU?.mandatory);
                break;
            case PATIENT_CONTEXT_TYPE.SDEC:
                prepareAssessmentList(assessmentsCfg?.SDEC?.mandatory);
                break;
            case PATIENT_CONTEXT_TYPE.INPATIENT: {
                const flat = _.flatMap(assessmentsCfg?.INPATIENT?.mandatory, ass => ass?.assessmentList);
                prepareAssessmentList(_.uniq(flat));
                break;
            }

            default:
                setFilteredAssessmentsList([]);
        }
    }, [patientType]);

    useEffect(() => {
        let filled = true;
        const list = [];

        filteredAssessmentsList.forEach(assessment => {
            const formContainer = formIds.find(form => form.id === assessment.code);
            if (formContainer && assessment.active) {
                try {
                    const isAddData = formContainer?.isAddData;
                    const path = assessment?.metadata?.path ?? {};
                    const data = _.get((isAddData ? patientAddData : patient), path.filled);
                    let filteredData = !!data;
                    if (data) {
                        filteredData = _.isArray(data) ? data : [data];
                        if (isAddData) {
                            filteredData = _.filter(filteredData, f => {
                                const activityId = f?.attendanceId;
                                const date = _.get(f, path.date);

                                if (activityId) {
                                    return patient?.admission?.__id === activityId;
                                }
                                if (date) {
                                    const startDate = moment(patient?.admission?.startDate);
                                    const isActive = _.isNil(patient?.admission?.endDate);
                                    const endDate = isActive
                                        ? moment()
                                        : moment(patient?.admission?.startDate);

                                    return moment(date).isBetween(startDate, endDate, null, '[]');
                                }
                                return null;
                            });
                        }
                    }

                    if (_.isEmpty(filteredData)) {
                        list.push(assessment?.description);
                        if (filled) filled = false;
                    }
                } catch (e) {
                    console.error(e);
                }
            }
        });
        setNoFilled(!filled);
        setAssessmentsLists(list);
    }, [patient, patientAddData, filteredAssessmentsList]);

    useEffect(() => {
        const mandatory = assCfg?.mandatory || DEFAULT_ASSESSMENTS_VALUE.mandatory;
        if (mandatory?.enabled) {
            dispatch(setBlockDischargeMandatoryAssessment(noFilled));
        } else {
            dispatch(setBlockDischargeMandatoryAssessment(false));
        }
    }, [noFilled, assCfg]);

    useEffect(() => {
        dispatch(setMandatoryAssessmentList(assessmentsLists));
    }, [assessmentsLists]);
};

export default useAllAssessmentsFiled;